import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateAvatarService {
  private avatar: Subject<void> = new Subject<void>();
  constructor() { }

  invokeUpdatedAvatar(active_company:any) {
    this.avatar.next(active_company);
  }

  getUpdatedAvatarObservable() {
    return this.avatar.asObservable();
  }
}
